import {InputLabelClassKey} from '@material-ui/core/InputLabel';
import {StyleRules} from '@material-ui/core/styles';

export const MuiInputLabel: Partial<StyleRules<InputLabelClassKey, {}>> = {
  formControl: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    fontSize: '0.8125rem',
    marginBottom: '3px',
    transform: 'none',
  },
  outlined: {
    transform: 'none',
    '&.MuiInputLabel-marginDense': {
      transform: 'none',
    },
  },
  filled: {
    transform: 'none',
    '&.MuiInputLabel-marginDense': {
      transform: 'none',
    },
  },
  marginDense: {
    transform: 'none',
  },
};
